;(function () {
  'use strict'

  angular.module('contrast.virtual-patch').controller(
    'AddVirtualPatchCtrl',
    // eslint-disable-next-line angular/di-unused
    function AddVirtualPatchCtrl(
      $scope,
      $location,
      $controller,
      UserService,
      virtualPatchService,
      ApplicationService,
      TechnologyService,
      VIRTUAL_PATCH,
      NOTIFICATION_TYPE_OPTIONS
    ) {
      'ngInject'

      var vm
      var baseCtrl

      this.$onInit = function () {
        vm = this
        baseCtrl = $controller('BaseVirtualPatchCtrl', {
          $scope: $scope
        })
        baseCtrl.$onInit()
        angular.extend(vm, baseCtrl)

        angular.extend($scope, {
          patch: {
            name: '',
            application_mode: VIRTUAL_PATCH.APPLICATION_MODE.ALL,
            technologies: [],
            languages: [],
            criterias: [],
            apps: []
          }
        })

        angular.extend($scope, {
          savePatch: savePatch
        })

        init()
      }

      function init() {
        baseCtrl.init().then(function () {
          vm.addCriteria()
          $scope.patch.apps = [NOTIFICATION_TYPE_OPTIONS.ALL]
        })
      }

      function savePatch() {
        var patchSettings = virtualPatchService.transformPatchSettings(
          $scope.patch
        )

        return virtualPatchService
          .addVirtualPatch(patchSettings)
          .then(function () {
            $location.path(UserService.buildUrl('/rules/patches'))
          })
      }

      this.$onInit()
    }
  )
})()
